import "./src/style.scss";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
let previousPage = '';

function detectTrafficSource(referrer) {
  if (!referrer) return '';
  try {
    const d = new URL(referrer).hostname.toLowerCase();
    if (d.includes('google.'))      return 'Google';
    if (d.includes('bing.'))        return 'Bing';
    if (d.includes('yahoo.'))       return 'Yahoo';
    if (d.includes('duckduckgo.'))  return 'DuckDuckGo';
    if (d.includes('baidu.'))       return 'Baidu';
    if (d.includes('yandex.'))      return 'Yandex';
    if (d.includes('facebook.'))    return 'Facebook';
    if (d.includes('instagram.'))   return 'Instagram';
    if (d.includes('twitter.') || d.includes('x.com')) return 'Twitter/X';
    if (d.includes('linkedin.'))    return 'LinkedIn';
    if (d.includes('youtube.'))     return 'YouTube';
    if (d.includes('tiktok.'))      return 'TikTok';
    if (d.includes('pinterest.'))   return 'Pinterest';
    if (d.includes('snapchat.'))    return 'Snapchat';
    if (d.includes('reddit.'))      return 'Reddit';
    if (d.includes('tripadvisor.')) return 'TripAdvisor';
    if (d.includes('booking.'))     return 'Booking.com';
    if (d.includes('expedia.'))     return 'Expedia';
    if (d.includes('agoda.'))       return 'Agoda';
    return d;
  } catch { return ''; }
}

function detectOrganicSource(referrer) {
  if (!referrer) return '';
  try {
    const d = new URL(referrer).hostname.toLowerCase();
    if (d.includes('google.') || d.includes('bing.') || d.includes('yahoo.') ||
        d.includes('duckduckgo.') || d.includes('baidu.') || d.includes('yandex.'))
      return 'Search Engine';
    if (d.includes('facebook.') || d.includes('instagram.') || d.includes('twitter.') ||
        d.includes('x.com') || d.includes('linkedin.') || d.includes('youtube.') ||
        d.includes('tiktok.') || d.includes('pinterest.') || d.includes('snapchat.'))
      return 'Social Media';
    if (d.includes('tripadvisor.') || d.includes('booking.') ||
        d.includes('expedia.') || d.includes('agoda.'))
      return 'Travel Site';
    if (d.includes('reddit.')) return 'Forum/Community';
    return 'Direct';
  } catch { return ''; }
}

export const onRouteUpdate = ({ location }) => {
  if (previousPage && previousPage !== location.pathname) {
    sessionStorage.setItem('previous_page', previousPage);
  }
  previousPage = location.pathname;
};

export const onInitialClientRender = () => {
  const params = new URLSearchParams(window.location.search);

  const utmSource     = params.get('utm_source')     || '';
  const utmMedium     = params.get('utm_medium')     || '';
  const utmCampaign   = params.get('utm_campaign')   || '';
  const utmTerm       = params.get('utm_term')       || '';
  const utmContent    = params.get('utm_content')    || '';
  const gclid         = params.get('gclid')          || '';
  const trafficSource = params.get('traffic_source') || '';
  const organic       = params.get('organic')        || '';
  const referrer      = params.get('referrer')       || '';

  const documentReferrer = document.referrer || '';

  if (utmSource)     sessionStorage.setItem('utm_source',     utmSource);
  if (utmMedium)     sessionStorage.setItem('utm_medium',     utmMedium);
  if (utmCampaign)   sessionStorage.setItem('utm_campaign',   utmCampaign);
  if (utmTerm)       sessionStorage.setItem('utm_term',       utmTerm);
  if (utmContent)    sessionStorage.setItem('utm_content',    utmContent);
  if (gclid)         sessionStorage.setItem('gclid',          gclid);
  if (trafficSource) sessionStorage.setItem('traffic_source', trafficSource);
  if (organic)       sessionStorage.setItem('organic',        organic);
  if (referrer)      sessionStorage.setItem('referrer',       referrer);

  if (!trafficSource && utmSource) {
    sessionStorage.setItem('traffic_source', utmSource.charAt(0).toUpperCase() + utmSource.slice(1));
  }

  if (gclid) {
    if (!sessionStorage.getItem('traffic_source')) sessionStorage.setItem('traffic_source', 'Google');
    if (!sessionStorage.getItem('organic'))        sessionStorage.setItem('organic', 'Search Engine');
  }

  if (!organic && utmMedium) {
    const mediumMap = {
      organic: 'Search Engine', cpc: 'Search Engine', ppc: 'Search Engine',
      social: 'Social Media', facebook: 'Social Media', instagram: 'Social Media',
      twitter: 'Social Media', linkedin: 'Social Media', youtube: 'Social Media',
      tiktok: 'Social Media', pinterest: 'Social Media', snapchat: 'Social Media',
      email: 'Email', referral: 'Referral', display: 'Display', banner: 'Display',
    };
    const derived = mediumMap[utmMedium.toLowerCase()]
      || utmMedium.charAt(0).toUpperCase() + utmMedium.slice(1);
    sessionStorage.setItem('organic', derived);
  }

  if (documentReferrer && !documentReferrer.startsWith(window.location.origin)) {
    sessionStorage.setItem('document_referrer', documentReferrer);
    const detectedTraffic = detectTrafficSource(documentReferrer);
    const detectedOrganic = detectOrganicSource(documentReferrer);
    if (!trafficSource && detectedTraffic) sessionStorage.setItem('traffic_source', detectedTraffic);
    if (!organic && detectedOrganic)       sessionStorage.setItem('organic',         detectedOrganic);
  }

  previousPage = window.location.pathname;
};
